var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222.08 158.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.28,158.05c-2.3,0-4.61-.88-6.36-2.64-3.51-3.51-3.51-9.21,0-12.73L182.97,2.64c3.52-3.52,9.21-3.52,12.73,0,3.51,3.51,3.51,9.21,0,12.73L55.64,155.42c-1.76,1.76-4.06,2.64-6.36,2.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.31,133.05h-29.91l-5.92,5.92c.14,1.31.77,2.6,2.01,3.58l13.26,7.95c1.32.69,2.79,1.05,4.27,1.05h2.04c1.49,0,2.96-.36,4.27-1.05l13.26-7.95c3.97-3.12,1.76-9.5-3.29-9.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.87,99.79c-5.92-1.81-11.94-3.2-18-4.21l-17.12,17.12c9.98.47,19.92,2.18,29.59,5.14.92.28,1.85.42,2.77.42,4.04,0,7.78-2.61,9.02-6.68,1.53-4.98-1.27-10.26-6.26-11.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,87.66c1.33,0,2.68-.28,3.96-.88,15.97-7.41,32.48-12.06,49.26-13.92l19.76-19.76c-1.02-.02-2.04-.04-3.07-.04-25.28,0-50.14,5.58-73.89,16.59-4.73,2.19-6.79,7.8-4.59,12.53,1.6,3.44,5.01,5.47,8.57,5.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.93,69.66c-5.91-2.74-11.89-5.15-17.93-7.21l-15.09,15.09c8.48,2.35,16.85,5.43,25.09,9.25,4.73,2.19,10.34.14,12.53-4.59,2.19-4.73.14-10.34-4.59-12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M138.29,28.93l16.28-16.28c-14.32-3.02-28.85-4.57-43.52-4.57-36.62,0-72.34,9.47-106.17,28.15-4.56,2.52-6.22,8.26-3.7,12.82,1.72,3.12,4.95,4.88,8.27,4.88,1.54,0,3.11-.38,4.55-1.18,31-17.12,63.65-25.8,97.04-25.8,9.14,0,18.23.67,27.25,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.21,36.24c-5.27-2.91-10.6-5.57-15.96-8.04l-14.32,14.32c7.13,2.99,14.18,6.39,21.15,10.24,4.56,2.52,10.3.86,12.83-3.7,2.52-4.56.86-10.3-3.7-12.82Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoWifi);
export default __webpack_public_path__ + "static/media/no-wifi.f75e84716940aa02cbb5febcbaddfd40.svg";
export { ForwardRef as ReactComponent };